import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  IconButton,
  Typography,
  Grid,
  TextField,
  Paper,
  InputAdornment,
  Button
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import LambdaFetch from '../functions/FetchFromLambda'
import LoadingButton from '../components/LoadingButton'
import { prDistirbCols } from '../constants/EmployeeCols'
import TableMui from '../components/TableMui'
import getTableOptions from '../constants/TableOptions'
import LoadingCircle from '../components/common/LoadingCircle'
import { smallScreenWidth } from '../constants/AppConstants'
import ServerSideAutoCompletev2 from '../functions/ServerSideAutoCompletev2'
import ReactTable from '../components/ReactTable'
import ReactTableServerSide from '../components/ReactTableServerSide'
import DateRangePicker from '../functions/DateRangePicker'
import dateDiff from '../utils/DateDiff'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    margin: '2rem 1rem'
  },
  treeRoot: {
    flexGrow: 1,
    margin: '1rem'
  }
}))

const defaultHeaders = {
  company: '',
  process_level: '',
  employee: '',
  fromDate: '',
  toDate: ''
}

export default function PayRollDistrib (props) {
  const [state, setstate] = useState({
    isLoading: false,
    data: null,
    fetched: true,
    tableKey: JSON.stringify(defaultHeaders)
  })
  const [showTable, setShowTable] = useState(false)
  const [headers, setHeaders] = useState(defaultHeaders)
  const [clearHeader, setClearHeaders] = React.useState(false)

  const classes = useStyles()

  const { credentials } = props.fetchInitialData

  const handleSubmit = async e => {
    e.preventDefault()
    const from = e.target.fromDate.value
    const to = e.target.toDate.value
    const diffrence = dateDiff(from, to, 'days')
    if (diffrence > 92) {
      props.fetchInitialData.createSnack(
        'Max date range is 90 days',
        'warning',
        3000
      )
      return null
    }

    if (JSON.stringify(headers) === state.tableKey) return null
    setShowTable(true)
    setstate({ ...state, isLoading: true, tableKey: JSON.stringify(headers) })
  }
  const fetchPrDistribData = async params => {
    try {
      const resp = await LambdaFetch(
        'payroll-distrib',
        'post',
        credentials.user.accessToken,
        JSON.stringify({
          action: 'get-prdistrib',
          ...params
        }),
        '',
        credentials
      )

      setstate({
        ...state,
        data: resp.data.prDistribData,
        isLoading: false
      })
    } catch (e) {
      console.log(e)
      setstate({ ...state, isLoading: false })
    }
  }

  const handleCallback = (values, error) => {
    if (error) {
      setstate({ ...state, isLoading: false })
      setShowTable(false)
      return null
    }
    setstate({ ...state, isLoading: false })
  }

  if (!state.fetched) {
    return <LoadingCircle />
  }

  return (
    <div style={{ padding: '1.5rem 0.5rem' }}>
      <IconButton
        style={{ borderRadius: '5px', position: 'absolute' }}
        size='small'
        onClick={() => props.history.push('/')}
        aria-label='delete'
      >
        <ArrowBackIcon />
        {props.fetchInitialData.credentials.appWidth > smallScreenWidth &&
          'Dashboard'}
      </IconButton>
      <Typography variant='h5' style={{ textAlign: 'center' }}>
        Payroll Distributions
      </Typography>
      <div className={classes.root}>
        <Paper elevation={0} style={{ padding: '1rem' }}>
          <form onSubmit={handleSubmit}>
            <Grid
              container
              alignContent='center'
              alignItems='flex-start'
              spacing={3}
            >
              {[
                {
                  id: 'company',
                  dataField: 'COMPANY',
                  label: 'Company',
                  dateType: 'string',
                  isRequired: false
                },
                {
                  id: 'process_level',
                  label: 'Process Level',
                  dataField: 'PROCESS_LEVEL',
                  dataType: 'string',
                  isRequired: false
                },
                {
                  id: 'employee',
                  dataField: 'EMPLOYEE',
                  label: 'Employee',
                  dateType: 'string',
                  isRequired: false
                }
              ].map(field => {
                return (
                  <Grid key={field.id} item>
                    <ServerSideAutoCompletev2
                      disabled={false}
                      required={field.isRequired}
                      id={field.id}
                      width='125px'
                      label={field.label}
                      key={clearHeader}
                      dontAutoHighlight
                      dontOpenOnFocus
                      accessToken={credentials.user.accessToken}
                      error={`No ${field.label} Found`}
                      variant='standard'
                      handleChange={(id, hit) => {
                        setHeaders({ ...headers, [field.id]: id })
                      }}
                      credentials={credentials}
                      apiResource='payroll-distrib'
                      secondaryParams={{
                        limit: 10,
                        lookupField: field.dataField,
                        action: 'autocomplete-prdistrib',
                        ...headers
                      }}
                    />
                  </Grid>
                )
              })}
              {[
                {
                  id: 'fromDate',
                  label: 'From Date',
                  isRequired: true
                },
                {
                  id: 'toDate',
                  label: 'To Date',
                  isRequired: true,
                  helperText: "90 day max range"
                }
              ].map(field => {
                return (
                  <Grid key={field.id} item>
                    <TextField
                      id={field.id}
                      key={clearHeader}
                      style={{ marginTop: '5px', width: '160px' }}
                      type={'date'}
                      required={field.isRequired}
                      label={field.label}
                      variant='standard'
                      value={headers.id}
                      fullWidth
                      helperText={field.helperText}
                      onChange={e => {
                        setHeaders({
                          ...headers,
                          [field.id]: !!e.target.value ? e.target.value : null
                        })
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position='start'>
                            <span />
                          </InputAdornment>
                        )
                      }}
                    />
                  </Grid>
                )
              })}
              {/* <Grid item>
                <DateRangePicker
                  key={clearHeader}
                  fromRequired
                  toRequired
                  maxRangeInWeeks={13}
                  handleChange={(fromDate, toDate) => {
                    setHeaders({
                      ...headers,
                      fromDate: fromDate,
                      toDate: toDate
                    })
                  }}
                />
              </Grid>*/}
            </Grid>

            <div style={{ marginTop: '1rem' }}>
              <LoadingButton
                label='Submit'
                disabled={!(headers.fiscalYear && headers.acctPeriod)}
                isLoading={state.isLoading}
                color='primaryVLButton'
                buttonType='submit'
              />
              {!!(
                headers.company ||
                headers.procee_level ||
                headers.employee ||
                headers.fromDate ||
                headers.toDate
              ) && (
                <Button
                  onClick={() => {
                    setClearHeaders(!clearHeader)
                    setHeaders(defaultHeaders)
                  }}
                  style={{ marginLeft: '0.5rem' }}
                >
                  {' '}
                  Clear
                </Button>
              )}
            </div>
          </form>
        </Paper>

        {!!showTable && (
          <div style={{ marginTop: '1rem ' }}>
            <ReactTableServerSide
              {...props}
              key={state.tableKey}
              params={{ ...headers }}
              action='get-prdistrib-serverside'
              apiResource={'payroll-distrib'}
              transform={r => r}
              tableTitle={''}
              tableColumns={prDistirbCols}
              callback={handleCallback}
              noPagination
              noSort
              downloadAction={'get-prdistrib-serverside-download'}
            />
          </div>
        )}
      </div>
    </div>
  )
}
